module.exports = __webpack_public_path__ + "static/media/productIntroForm2.346652c7.jpg";